"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayedDamage = void 0;
class DelayedDamage {
    constructor(effectType, primaryAttribute, type, power) {
        this.effectType = effectType;
        this.primaryAttribute = primaryAttribute;
        this.type = type;
        this.power = power;
    }
}
exports.DelayedDamage = DelayedDamage;
DelayedDamage.Focus = (effectType, type, power) => new DelayedDamage(effectType, "Focus", type, power);
DelayedDamage.Power = (effectType, type, power) => new DelayedDamage(effectType, "Power", type, power);
